import styled from 'styled-components/macro'
import MoreProducts from '../../components/Product/MoreProducts'

export const ProductMoreProducts = styled(MoreProducts)`
  margin: 11.7rem 0 12.3rem;
`
